import React, { useState } from "react";
import "./AppointmentScheduler2.css";
import logo2 from "./logo2.png";
import OutpatientNavigator from "./OutpatientNavigator";

const appointments = [
  {
    id: 1,
    time: "8:00 AM",
    patient: "Sarah Johnson",
    visit: "Follow-up",
    status: "Completed",
    interactive: false,
  },
  {
    id: 2,
    time: "8:30 AM",
    patient: "Michael Chen",
    visit: "Diabetes",
    status: "Completed",
    interactive: false,
  },
  {
    id: 3,
    time: "9:00 AM",
    patient: "Emily Davis",
    visit: "Cardiology",
    status: "Waiting",
    interactive: false,
  },
  {
    id: 4,
    time: "9:30 AM",
    patient: "John Smith",
    visit: "Annual Wellness",
    status: "Ready",
    interactive: true,
  },
  {
    id: 5,
    time: "10:00 AM",
    patient: "Lisa Martinez",
    visit: "New Patient",
    status: "Scheduled",
    interactive: false,
  },
];

export default function AppointmentScheduler() {
  const [selectedPatient, setSelectedPatient] = useState(null);

  if (selectedPatient) {
    return (
      <OutpatientNavigator
        patient={selectedPatient}
        onBack={() => setSelectedPatient(null)}
      />
    );
  }

  return (
    <div className="scheduler-page">

      <div className="scheduler-header">

        <img src={logo2} alt="" />

        <div>

          <h1>Ambulatory Care Scheduler</h1>

          <p>Virtual Care Clinic</p>

        </div>

      </div>

      <div className="provider-bar">

        <div>

          <strong>Provider</strong>

          <span>Dr. James Halpert</span>

        </div>

        <div>

          <strong>Location</strong>

          <span>Virtual Primary Care</span>

        </div>

        <div>

          <strong>Date</strong>

          <span>Today</span>

        </div>

      </div>

      <table className="schedule-table">

        <thead>

          <tr>

            <th>Time</th>

            <th>Patient</th>

            <th>Visit</th>

            <th>Status</th>

          </tr>

        </thead>

        <tbody>

          {appointments.map((appt) => (

            <tr
              key={appt.id}
              className={
                appt.interactive
                  ? "clickable"
                  : ""
              }
              onClick={() =>
                appt.interactive &&
                setSelectedPatient(appt)
              }
            >

              <td>{appt.time}</td>

              <td>{appt.patient}</td>

              <td>{appt.visit}</td>

              <td>

                <span
                  className={`status ${appt.status
                    .replace(/\s/g, "")
                    .toLowerCase()}`}
                >

                  {appt.status}

                </span>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

      <p className="scheduler-note">
        Click <strong>John Smith</strong> to begin the virtual visit demo.
      </p>

    </div>
  );
}